import { GatsbyBrowser, WrapRootElementBrowserArgs } from 'gatsby';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ActiveCampaignTracking } from '../components/0-atoms/ActiveCampaignTracking';
import { MauticTracking } from '../components/0-atoms/MauticTracking';

const client = new QueryClient();

export const WrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}: WrapRootElementBrowserArgs) => (
  <>
    <QueryClientProvider client={client}>{element}</QueryClientProvider>
    <ActiveCampaignTracking />
    <MauticTracking />
  </>
);
